// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23888%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Ccircle cx=%2711%27 cy=%2711%27 r=%278%27%3E%3C/circle%3E%3Cline x1=%2721%27 y1=%2721%27 x2=%2716.65%27 y2=%2716.65%27%3E%3C/line%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Training Dashboard — full-page layout with its own sidebar, matching the ISD/CSD dashboards.
   Uses the shell's universal Fleet OS theme tokens. The .training-root wrapper maps a couple of
   status colours and scopes them so nothing leaks out. (The previous CSS targeted a different
   design system's variables — --spacing-*, --surface-*, --accent-primary — none of which exist
   here, so nothing was styled.) */
.training-root {
  color-scheme: dark;
  --green: #22c55e;
  --amber: #f59e0b;
  --red: #ef4444;
}
:root[data-theme="light"] .training-root { color-scheme: light; }

.training-layout {
  display: flex;
  height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: var(--font-family);
  font-size: 0.9rem;
}

/* ── Sidebar ── */
.training-sidebar {
  width: 250px; min-width: 250px; height: 100vh; position: sticky; top: 0;
  display: flex; flex-direction: column;
  background: var(--bg-sidebar); border-right: 1px solid var(--border-subtle);
  z-index: 50; overflow-y: auto;
}
.training-sidebar::-webkit-scrollbar { width: 4px; }
.training-sidebar::-webkit-scrollbar-thumb { background: var(--border-subtle); border-radius: 2px; }

.training-sidebar-brand {
  display: flex; align-items: center; gap: 10px;
  padding: 20px 18px 16px; border-bottom: 1px solid var(--border-subtle);
}
.training-sidebar-back {
  background: var(--bg-glass); border: 1px solid var(--border-subtle); border-radius: 8px;
  color: var(--text-muted); width: 34px; height: 34px; display: flex; align-items: center;
  justify-content: center; cursor: pointer; transition: all 0.2s ease; flex-shrink: 0;
}
.training-sidebar-back:hover { background: var(--bg-glass-hover); color: var(--text-primary); }
.training-sidebar-brand-info { display: flex; align-items: center; gap: 10px; }
.training-sidebar-brand-icon {
  width: 34px; height: 34px; border-radius: 9px;
  background: linear-gradient(135deg, var(--accent-emerald), #059669);
  display: flex; align-items: center; justify-content: center;
  font-weight: 800; font-size: 0.72rem; color: #fff; letter-spacing: 0.5px; flex-shrink: 0;
}
.training-sidebar-brand-name { display: block; font-weight: 700; font-size: 0.88rem; color: var(--text-primary); letter-spacing: -0.3px; }
.training-sidebar-brand-sub { display: block; font-size: 0.68rem; color: var(--text-muted); margin-top: 1px; }

/* ── Nav ── */
.training-sidebar-nav { flex: 1 1; padding: 12px 10px; overflow-y: auto; }
.training-nav-section { margin-bottom: 20px; }
.training-nav-section-title {
  padding: 0 10px 6px; font-size: 0.65rem; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.8px; color: var(--text-muted); opacity: 0.6;
}
.training-nav-item {
  display: flex; align-items: center; gap: 10px; width: 100%;
  padding: 8px 12px; border-radius: 8px; font-size: 0.82rem; font-weight: 500;
  color: var(--text-secondary); background: transparent; border: none; cursor: pointer;
  text-align: left; transition: all 0.15s ease; margin-bottom: 2px; font-family: inherit;
}
.training-nav-item:hover { background: var(--bg-glass-hover); color: var(--text-primary); }
.training-nav-item.active { background: rgba(16, 185, 129, 0.1); color: var(--accent-emerald); }
.training-nav-item.active .training-nav-icon { color: var(--accent-emerald); }
.training-nav-icon { width: 18px; height: 18px; flex-shrink: 0; color: var(--text-muted); display: flex; align-items: center; justify-content: center; }

/* ── Sidebar footer ── */
.training-sidebar-footer { padding: 14px; border-top: 1px solid var(--border-subtle); display: flex; flex-direction: column; gap: 10px; }
.training-sync-btn {
  display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; padding: 10px;
  background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.2); border-radius: 8px;
  color: var(--accent-emerald); font-family: inherit; font-size: 0.82rem; font-weight: 700;
  letter-spacing: 0.3px; cursor: pointer; transition: all 0.2s ease;
}
.training-sync-btn:hover { background: rgba(16, 185, 129, 0.15); border-color: rgba(16, 185, 129, 0.3); color: var(--accent-emerald-hover); }
.training-sync-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.training-sync-btn.spinning svg { animation: training-spin 0.7s linear infinite; }
@keyframes training-spin { to { transform: rotate(360deg); } }

/* ── Main content ── */
.training-main { flex: 1 1; min-width: 0; padding: 24px 32px 48px; overflow-y: auto; height: 100vh; }

.training-page-header { margin-bottom: 24px; }
.training-page-title { font-size: 1.6rem; font-weight: 800; color: var(--text-primary); letter-spacing: -0.5px; margin: 0 0 4px; }
.training-page-subtitle { font-size: 0.82rem; color: var(--text-muted); margin: 0; }

/* ── Banner ── */
.tr-banner { padding: 10px 14px; border-radius: 8px; font-size: 0.82rem; margin-bottom: 18px; }
.tr-banner--error { background: rgba(239,68,68,0.12); color: #fca5a5; border: 1px solid rgba(239,68,68,0.3); }
.tr-banner--ok { background: rgba(16,185,129,0.1); color: var(--accent-emerald); border: 1px solid rgba(16,185,129,0.2); }

/* ── Cards + tables ── */
.tr-card {
  background: var(--bg-card); border: 1px solid var(--border-subtle); border-radius: 14px;
  padding: 8px 4px; margin-bottom: 18px; box-shadow: var(--shadow-sm); overflow: hidden;
}
.tr-table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
.tr-table th {
  color: var(--text-muted); font-weight: 600; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.04em;
  text-align: left; padding: 12px 18px; border-bottom: 1px solid var(--border-subtle); white-space: nowrap;
}
.tr-table td { padding: 12px 18px; border-bottom: 1px solid var(--border-subtle); color: var(--text-primary); vertical-align: middle; }
.tr-table tbody tr:last-child td { border-bottom: none; }
.tr-table tbody tr:hover { background: var(--bg-glass); }
.tr-num { font-variant-numeric: tabular-nums; }

/* completion bar */
.tr-bar-wrap { display: flex; align-items: center; gap: 10px; min-width: 180px; }
.tr-bar { flex: 1 1; height: 6px; border-radius: 3px; background: var(--bg-glass); overflow: hidden; }
.tr-bar > div { height: 100%; border-radius: 3px; }
.tr-pct { font-size: 0.8rem; font-weight: 700; font-variant-numeric: tabular-nums; min-width: 38px; text-align: right; }

.tr-badge {
  font-size: 0.68rem; font-weight: 700; padding: 2px 9px; border-radius: 999px; display: inline-block;
  white-space: nowrap; background: var(--bg-glass); color: var(--text-secondary);
}

/* ── KPI cards ── */
.tr-kpi-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: 14px; }
.tr-kpi {
  background: var(--bg-card); border: 1px solid var(--border-subtle); border-top: 3px solid var(--text-muted);
  border-radius: 12px; padding: 16px; box-shadow: var(--shadow-sm);
}
.tr-kpi--ok { border-top-color: var(--green); }
.tr-kpi--bad { border-top-color: var(--red); }
.tr-kpi__label { font-size: 0.72rem; color: var(--text-secondary); font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; }
.tr-kpi__value { font-size: 1.9rem; font-weight: 800; color: var(--text-primary); margin: 6px 0 2px; font-variant-numeric: tabular-nums; }
.tr-kpi__target { font-size: 0.72rem; color: var(--text-muted); }

/* ── States ── */
.tr-empty { padding: 40px 24px; text-align: center; color: var(--text-muted); font-size: 0.85rem; }
.training-error {
  margin: 40px auto; max-width: 460px; padding: 20px; text-align: center; color: #fca5a5;
  background: rgba(239,68,68,0.12); border: 1px solid rgba(239,68,68,0.3); border-radius: 12px;
}
.training-loading { padding: 60px; text-align: center; color: var(--text-secondary); }

/* ── Responsive ── */
@media (max-width: 768px) {
  .training-layout { flex-direction: column; height: auto; }
  .training-sidebar { width: 100%; min-width: 100%; height: auto; position: relative; border-right: none; border-bottom: 1px solid var(--border-subtle); }
  .training-sidebar-nav { display: flex; flex-wrap: wrap; gap: 6px; }
  .training-nav-section { margin-bottom: 0; }
  .training-nav-section-title { display: none; }
  .training-main { padding: 20px 16px; height: auto; }
}

/* ── Topbar ── */
.tr-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-subtle);
  position: sticky;
  top: 0;
  z-index: 40;
}
.tr-topbar-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
.tr-breadcrumbs {
  font-size: 0.85rem;
  color: var(--text-muted);
  font-weight: 500;
}
.tr-breadcrumbs strong {
  color: var(--text-primary);
  font-weight: 700;
}
.tr-search {
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  border-radius: 9999px;
  padding: 0.4rem 1rem 0.4rem 2.2rem;
  color: var(--text-primary);
  font-size: 0.82rem;
  width: 280px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 10px center;
  transition: all 0.2s;
}
.tr-search:focus {
  outline: none;
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.tr-topbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.tr-user-dropdown {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
}
.tr-user-dropdown:hover {
  background: var(--bg-glass-hover);
}
.tr-topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.tr-topbar-btn {
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.tr-topbar-btn:hover {
  background: var(--bg-glass-hover);
  color: var(--text-primary);
}
.tr-sync-btn-top {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.2);
  color: #60a5fa;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.tr-sync-btn-top:hover {
  background: rgba(59, 130, 246, 0.2);
}
.tr-topbar-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.72rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
  justify-content: flex-end;
  padding-right: 24px;
}

/* ── Overview Tiles ── */
.tr-tiles {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 0 24px;
}
.tr-tile {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  padding: 1.25rem;
  text-align: left;
  transition: all 0.2s ease;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
}
.tr-tile:hover {
  background: var(--bg-glass-hover);
  transform: translateY(-2px);
}
.tr-tile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-muted);
}
.tr-tile-value {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1;
  margin: 0.75rem 0 0.25rem;
  color: var(--text-primary);
}
.tr-tile-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
}
.tr-tile-sub {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
}
.tr-tile-sub.alert { color: #fca5a5; }
.tr-tile-sub.warn { color: #fbbf24; }
.tr-tile-sub.ok { color: var(--green); }

/* ── Sidebar Badges & Footers ── */
.nav-badge {
  margin-left: auto;
  background: var(--bg-glass);
  color: var(--text-muted);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.1rem 0.5rem;
  border-radius: 9999px;
}
.training-nav-item.active .nav-badge {
  background: rgba(16, 185, 129, 0.2);
  color: var(--accent-emerald);
}
.sidebar-btn-outline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.5rem;
  background: transparent;
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  color: var(--text-muted);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.5rem;
  transition: all 0.2s;
}
.sidebar-btn-outline:hover {
  background: var(--bg-glass-hover);
  color: var(--text-primary);
}

/* ── Action Buttons ── */
.row-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.7rem;
  border-radius: 9999px;
  font-size: 0.72rem;
  font-weight: 600;
  border: 1px solid var(--border-subtle);
  background: var(--bg-glass);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}
.btn-action:hover {
  background: var(--bg-glass-hover);
}
.btn-action-primary {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.35);
  color: #60a5fa;
}
.btn-action-primary:hover {
  background: rgba(59, 130, 246, 0.25);
}


/* ── Tags / badges (pill) ── */
.tag {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.15rem 0.55rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 600;
  border: 1px solid var(--border-subtle);
  background: var(--bg-glass);
  color: var(--text-muted);
  white-space: nowrap;
}
.tag-neutral {
  background: var(--bg-glass);
  border-color: var(--border-subtle);
  color: var(--text-muted);
}
.tag-green {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.35);
  color: var(--green);
}
.tag-accent {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.35);
  color: #60a5fa;
}
.tag-danger {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.35);
  color: #fca5a5;
}
.tag-warn {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.35);
  color: #fbbf24;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.15rem 0.55rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 700;
  border: 1px solid transparent;
}
.badge .dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
}
.badge-green {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.35);
  color: var(--green);
}
.badge-danger {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.35);
  color: #fca5a5;
}
.badge-warn {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.35);
  color: #fbbf24;
}

/* ── Avatars ── */
.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  font-weight: 700;
  color: #0f111a;
  flex-shrink: 0;
}

/* ── Meter ── */
.meter {
  position: relative;
  height: 8px;
  border-radius: 9999px;
  background: var(--bg-glass);
  overflow: hidden;
}
.meter-fill {
  height: 100%;
  border-radius: 9999px;
  transition: width 0.4s ease;
}
.meter-target {
  position: absolute;
  top: -2px;
  bottom: -2px;
  width: 2px;
  background: rgba(255, 255, 255, 0.45);
  border-radius: 2px;
}

/* ── List shell / rows ── */
.list-shell {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.list-row {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.9rem 1.1rem;
  transition: background 0.2s ease;
}
.list-row + .list-row {
  border-top: 1px solid var(--border-subtle);
}
.list-row:hover {
  background: var(--bg-glass-hover);
}

.flex { display: flex; }
.flex-col { flex-direction: column; }
.items-center { align-items: center; }
.items-start { align-items: flex-start; }
.items-end { align-items: flex-end; }
.justify-between { justify-content: space-between; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }
.flex-1 { flex: 1 1; }
.flex-wrap { flex-wrap: wrap; }
.shrink-0 { flex-shrink: 0; }
.min-w-0 { min-width: 0; }
.gap-1 { gap: 0.35rem; }
.gap-2 { gap: 0.6rem; }
.gap-3 { gap: 0.85rem; }
.ml-auto { margin-left: auto; }
.mt-1 { margin-top: 0.35rem; }
.mt-2 { margin-top: 0.6rem; }
.mt-3 { margin-top: 0.85rem; }
.text-right { text-align: right; }
.text-center { text-align: center; }
.truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.font-semibold { font-weight: 600; }
.font-bold { font-weight: 700; }
.text-xs { font-size: 0.72rem; }
.text-sm { font-size: 0.82rem; }
.whitespace-nowrap { white-space: nowrap; }
.text-left { text-align: left; }

.source-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.72rem;
  color: var(--text-muted);
  font-weight: 500;
  white-space: nowrap;
  transition: color 0.2s ease;
}
.source-link:hover {
  color: var(--accent-emerald);
}
.row-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: var(--bg-glass);
  color: var(--text-primary);
  display: grid;
  place-items: center;
  flex-shrink: 0;
}
.row-icon-pub {
  background: rgba(16, 185, 129, 0.12);
  color: var(--green);
}

.kpi-delta {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.5rem;
  font-size: 0.72rem;
  font-weight: 600;
}
.kpi-good { color: var(--green); }
.kpi-bad { color: var(--red); }
.kpi-formula {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  margin-top: 0.6rem;
  font-size: 0.68rem;
  line-height: 1.35;
  color: var(--text-muted);
}
.kpi-foot {
  margin-top: auto;
  padding-top: 0.85rem;
  margin-top: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.7rem;
  color: var(--text-muted);
  border-top: 1px solid var(--border-subtle);
}
.kpi-hash {
  font-family: ui-monospace, monospace;
  font-size: 0.62rem;
  color: var(--text-muted);
}
.stepper {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 36rem;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
}
.step {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--text-muted);
}
.step-done {
  color: var(--green);
}
.step-cur {
  color: var(--text-primary);
  font-weight: 700;
}
.step-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  display: inline-block;
}
.step-dot-cur {
  background: var(--green);
}
.step-dot-todo {
  border: 1px solid var(--border-subtle);
}
.step-line {
  width: 20px;
  height: 2px;
  border-radius: 2px;
  background: var(--border-subtle);
}
.step-line-done {
  background: rgba(16, 185, 129, 0.4);
}
`, "",{"version":3,"sources":["webpack://./../training-dashboard/src/components/training/training.css"],"names":[],"mappings":"AAAA;;;;kCAIkC;AAClC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA,2CAA2C,mBAAmB,EAAE;;AAEhE;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,YAAY,EAAE,gBAAgB,EAAE,aAAa,EAAE,gBAAgB,EAAE,MAAM;EACvE,aAAa,EAAE,sBAAsB;EACrC,6BAA6B,EAAE,4CAA4C;EAC3E,WAAW,EAAE,gBAAgB;AAC/B;AACA,uCAAuC,UAAU,EAAE;AACnD,6CAA6C,gCAAgC,EAAE,kBAAkB,EAAE;;AAEnG;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,uBAAuB,EAAE,6CAA6C;AACxE;AACA;EACE,2BAA2B,EAAE,sCAAsC,EAAE,kBAAkB;EACvF,wBAAwB,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB;EACvF,uBAAuB,EAAE,eAAe,EAAE,yBAAyB,EAAE,cAAc;AACrF;AACA,+BAA+B,iCAAiC,EAAE,0BAA0B,EAAE;AAC9F,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC9E;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,mEAAmE;EACnE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB,EAAE,kBAAkB,EAAE,WAAW,EAAE,qBAAqB,EAAE,cAAc;AAC1F;AACA,+BAA+B,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,sBAAsB,EAAE;AACzI,8BAA8B,cAAc,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE;;AAE7G,cAAc;AACd,wBAAwB,SAAO,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACvE,wBAAwB,mBAAmB,EAAE;AAC7C;EACE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB;EACpF,qBAAqB,EAAE,wBAAwB,EAAE,YAAY;AAC/D;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,WAAW;EAC1D,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB;EAC3E,4BAA4B,EAAE,uBAAuB,EAAE,YAAY,EAAE,eAAe;EACpF,gBAAgB,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,oBAAoB;AACxF;AACA,2BAA2B,iCAAiC,EAAE,0BAA0B,EAAE;AAC1F,4BAA4B,mCAAmC,EAAE,4BAA4B,EAAE;AAC/F,+CAA+C,4BAA4B,EAAE;AAC7E,qBAAqB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,wBAAwB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;;AAEvJ,yBAAyB;AACzB,2BAA2B,aAAa,EAAE,0CAA0C,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACxI;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,WAAW,EAAE,aAAa;EACjG,mCAAmC,EAAE,yCAAyC,EAAE,kBAAkB;EAClG,4BAA4B,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB;EACxF,qBAAqB,EAAE,eAAe,EAAE,yBAAyB;AACnE;AACA,2BAA2B,oCAAoC,EAAE,qCAAqC,EAAE,kCAAkC,EAAE;AAC5I,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,kCAAkC,6CAA6C,EAAE;AACjF,2BAA2B,KAAK,yBAAyB,EAAE,EAAE;;AAE7D,uBAAuB;AACvB,iBAAiB,SAAO,EAAE,YAAY,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,aAAa,EAAE;;AAElG,wBAAwB,mBAAmB,EAAE;AAC7C,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACjI,0BAA0B,kBAAkB,EAAE,wBAAwB,EAAE,SAAS,EAAE;;AAEnF,iBAAiB;AACjB,aAAa,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC9F,oBAAoB,gCAAgC,EAAE,cAAc,EAAE,qCAAqC,EAAE;AAC7G,iBAAiB,gCAAgC,EAAE,4BAA4B,EAAE,sCAAsC,EAAE;;AAEzH,yBAAyB;AACzB;EACE,0BAA0B,EAAE,sCAAsC,EAAE,mBAAmB;EACvF,gBAAgB,EAAE,mBAAmB,EAAE,4BAA4B,EAAE,gBAAgB;AACvF;AACA,YAAY,WAAW,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACxE;EACE,wBAAwB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,sBAAsB;EAChH,gBAAgB,EAAE,kBAAkB,EAAE,6CAA6C,EAAE,mBAAmB;AAC1G;AACA,eAAe,kBAAkB,EAAE,6CAA6C,EAAE,0BAA0B,EAAE,sBAAsB,EAAE;AACtI,mCAAmC,mBAAmB,EAAE;AACxD,2BAA2B,2BAA2B,EAAE;AACxD,UAAU,kCAAkC,EAAE;;AAE9C,mBAAmB;AACnB,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAChF,UAAU,SAAO,EAAE,WAAW,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AACnG,gBAAgB,YAAY,EAAE,kBAAkB,EAAE;AAClD,UAAU,iBAAiB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAEvH;EACE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,qBAAqB;EACnG,mBAAmB,EAAE,2BAA2B,EAAE,4BAA4B;AAChF;;AAEA,oBAAoB;AACpB,eAAe,aAAa,EAAE,4DAA4D,EAAE,SAAS,EAAE;AACvG;EACE,0BAA0B,EAAE,sCAAsC,EAAE,uCAAuC;EAC3G,mBAAmB,EAAE,aAAa,EAAE,4BAA4B;AAClE;AACA,cAAc,8BAA8B,EAAE;AAC9C,eAAe,4BAA4B,EAAE;AAC7C,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACxI,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,kCAAkC,EAAE;AACzI,kBAAkB,kBAAkB,EAAE,wBAAwB,EAAE;;AAEhE,iBAAiB;AACjB,YAAY,kBAAkB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;AAClG;EACE,iBAAiB,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,EAAE,cAAc;EACtF,gCAAgC,EAAE,qCAAqC,EAAE,mBAAmB;AAC9F;AACA,oBAAoB,aAAa,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;;AAErF,qBAAqB;AACrB;EACE,mBAAmB,sBAAsB,EAAE,YAAY,EAAE;EACzD,oBAAoB,WAAW,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,6CAA6C,EAAE;EACvJ,wBAAwB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;EAClE,wBAAwB,gBAAgB,EAAE;EAC1C,8BAA8B,aAAa,EAAE;EAC7C,iBAAiB,kBAAkB,EAAE,YAAY,EAAE;AACrD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,qBAAqB;EACrB,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,yDAAmV;EACnV,4BAA4B;EAC5B,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,qBAAqB,cAAc,EAAE;AACrC,oBAAoB,cAAc,EAAE;AACpC,kBAAkB,mBAAmB,EAAE;;AAEvC,mCAAmC;AACnC;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;;;AAGA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iCAAiC;AACnC;;AAEA,QAAQ,aAAa,EAAE;AACvB,YAAY,sBAAsB,EAAE;AACpC,gBAAgB,mBAAmB,EAAE;AACrC,eAAe,uBAAuB,EAAE;AACxC,aAAa,qBAAqB,EAAE;AACpC,mBAAmB,8BAA8B,EAAE;AACnD,kBAAkB,uBAAuB,EAAE;AAC3C,eAAe,yBAAyB,EAAE;AAC1C,UAAU,SAAO,EAAE;AACnB,aAAa,eAAe,EAAE;AAC9B,YAAY,cAAc,EAAE;AAC5B,WAAW,YAAY,EAAE;AACzB,SAAS,YAAY,EAAE;AACvB,SAAS,WAAW,EAAE;AACtB,SAAS,YAAY,EAAE;AACvB,WAAW,iBAAiB,EAAE;AAC9B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,mBAAmB,EAAE;AAC7B,cAAc,iBAAiB,EAAE;AACjC,eAAe,kBAAkB,EAAE;AACnC,YAAY,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5E,iBAAiB,gBAAgB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,WAAW,kBAAkB,EAAE;AAC/B,WAAW,kBAAkB,EAAE;AAC/B,qBAAqB,mBAAmB,EAAE;AAC1C,aAAa,gBAAgB,EAAE;;AAE/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,YAAY,mBAAmB,EAAE;AACjC,WAAW,iBAAiB,EAAE;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mCAAmC;AACrC","sourcesContent":["/* Training Dashboard — full-page layout with its own sidebar, matching the ISD/CSD dashboards.\n   Uses the shell's universal Fleet OS theme tokens. The .training-root wrapper maps a couple of\n   status colours and scopes them so nothing leaks out. (The previous CSS targeted a different\n   design system's variables — --spacing-*, --surface-*, --accent-primary — none of which exist\n   here, so nothing was styled.) */\n.training-root {\n  color-scheme: dark;\n  --green: #22c55e;\n  --amber: #f59e0b;\n  --red: #ef4444;\n}\n:root[data-theme=\"light\"] .training-root { color-scheme: light; }\n\n.training-layout {\n  display: flex;\n  height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: var(--font-family);\n  font-size: 0.9rem;\n}\n\n/* ── Sidebar ── */\n.training-sidebar {\n  width: 250px; min-width: 250px; height: 100vh; position: sticky; top: 0;\n  display: flex; flex-direction: column;\n  background: var(--bg-sidebar); border-right: 1px solid var(--border-subtle);\n  z-index: 50; overflow-y: auto;\n}\n.training-sidebar::-webkit-scrollbar { width: 4px; }\n.training-sidebar::-webkit-scrollbar-thumb { background: var(--border-subtle); border-radius: 2px; }\n\n.training-sidebar-brand {\n  display: flex; align-items: center; gap: 10px;\n  padding: 20px 18px 16px; border-bottom: 1px solid var(--border-subtle);\n}\n.training-sidebar-back {\n  background: var(--bg-glass); border: 1px solid var(--border-subtle); border-radius: 8px;\n  color: var(--text-muted); width: 34px; height: 34px; display: flex; align-items: center;\n  justify-content: center; cursor: pointer; transition: all 0.2s ease; flex-shrink: 0;\n}\n.training-sidebar-back:hover { background: var(--bg-glass-hover); color: var(--text-primary); }\n.training-sidebar-brand-info { display: flex; align-items: center; gap: 10px; }\n.training-sidebar-brand-icon {\n  width: 34px; height: 34px; border-radius: 9px;\n  background: linear-gradient(135deg, var(--accent-emerald), #059669);\n  display: flex; align-items: center; justify-content: center;\n  font-weight: 800; font-size: 0.72rem; color: #fff; letter-spacing: 0.5px; flex-shrink: 0;\n}\n.training-sidebar-brand-name { display: block; font-weight: 700; font-size: 0.88rem; color: var(--text-primary); letter-spacing: -0.3px; }\n.training-sidebar-brand-sub { display: block; font-size: 0.68rem; color: var(--text-muted); margin-top: 1px; }\n\n/* ── Nav ── */\n.training-sidebar-nav { flex: 1; padding: 12px 10px; overflow-y: auto; }\n.training-nav-section { margin-bottom: 20px; }\n.training-nav-section-title {\n  padding: 0 10px 6px; font-size: 0.65rem; font-weight: 700; text-transform: uppercase;\n  letter-spacing: 0.8px; color: var(--text-muted); opacity: 0.6;\n}\n.training-nav-item {\n  display: flex; align-items: center; gap: 10px; width: 100%;\n  padding: 8px 12px; border-radius: 8px; font-size: 0.82rem; font-weight: 500;\n  color: var(--text-secondary); background: transparent; border: none; cursor: pointer;\n  text-align: left; transition: all 0.15s ease; margin-bottom: 2px; font-family: inherit;\n}\n.training-nav-item:hover { background: var(--bg-glass-hover); color: var(--text-primary); }\n.training-nav-item.active { background: rgba(16, 185, 129, 0.1); color: var(--accent-emerald); }\n.training-nav-item.active .training-nav-icon { color: var(--accent-emerald); }\n.training-nav-icon { width: 18px; height: 18px; flex-shrink: 0; color: var(--text-muted); display: flex; align-items: center; justify-content: center; }\n\n/* ── Sidebar footer ── */\n.training-sidebar-footer { padding: 14px; border-top: 1px solid var(--border-subtle); display: flex; flex-direction: column; gap: 10px; }\n.training-sync-btn {\n  display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; padding: 10px;\n  background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.2); border-radius: 8px;\n  color: var(--accent-emerald); font-family: inherit; font-size: 0.82rem; font-weight: 700;\n  letter-spacing: 0.3px; cursor: pointer; transition: all 0.2s ease;\n}\n.training-sync-btn:hover { background: rgba(16, 185, 129, 0.15); border-color: rgba(16, 185, 129, 0.3); color: var(--accent-emerald-hover); }\n.training-sync-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.training-sync-btn.spinning svg { animation: training-spin 0.7s linear infinite; }\n@keyframes training-spin { to { transform: rotate(360deg); } }\n\n/* ── Main content ── */\n.training-main { flex: 1; min-width: 0; padding: 24px 32px 48px; overflow-y: auto; height: 100vh; }\n\n.training-page-header { margin-bottom: 24px; }\n.training-page-title { font-size: 1.6rem; font-weight: 800; color: var(--text-primary); letter-spacing: -0.5px; margin: 0 0 4px; }\n.training-page-subtitle { font-size: 0.82rem; color: var(--text-muted); margin: 0; }\n\n/* ── Banner ── */\n.tr-banner { padding: 10px 14px; border-radius: 8px; font-size: 0.82rem; margin-bottom: 18px; }\n.tr-banner--error { background: rgba(239,68,68,0.12); color: #fca5a5; border: 1px solid rgba(239,68,68,0.3); }\n.tr-banner--ok { background: rgba(16,185,129,0.1); color: var(--accent-emerald); border: 1px solid rgba(16,185,129,0.2); }\n\n/* ── Cards + tables ── */\n.tr-card {\n  background: var(--bg-card); border: 1px solid var(--border-subtle); border-radius: 14px;\n  padding: 8px 4px; margin-bottom: 18px; box-shadow: var(--shadow-sm); overflow: hidden;\n}\n.tr-table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }\n.tr-table th {\n  color: var(--text-muted); font-weight: 600; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.04em;\n  text-align: left; padding: 12px 18px; border-bottom: 1px solid var(--border-subtle); white-space: nowrap;\n}\n.tr-table td { padding: 12px 18px; border-bottom: 1px solid var(--border-subtle); color: var(--text-primary); vertical-align: middle; }\n.tr-table tbody tr:last-child td { border-bottom: none; }\n.tr-table tbody tr:hover { background: var(--bg-glass); }\n.tr-num { font-variant-numeric: tabular-nums; }\n\n/* completion bar */\n.tr-bar-wrap { display: flex; align-items: center; gap: 10px; min-width: 180px; }\n.tr-bar { flex: 1; height: 6px; border-radius: 3px; background: var(--bg-glass); overflow: hidden; }\n.tr-bar > div { height: 100%; border-radius: 3px; }\n.tr-pct { font-size: 0.8rem; font-weight: 700; font-variant-numeric: tabular-nums; min-width: 38px; text-align: right; }\n\n.tr-badge {\n  font-size: 0.68rem; font-weight: 700; padding: 2px 9px; border-radius: 999px; display: inline-block;\n  white-space: nowrap; background: var(--bg-glass); color: var(--text-secondary);\n}\n\n/* ── KPI cards ── */\n.tr-kpi-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: 14px; }\n.tr-kpi {\n  background: var(--bg-card); border: 1px solid var(--border-subtle); border-top: 3px solid var(--text-muted);\n  border-radius: 12px; padding: 16px; box-shadow: var(--shadow-sm);\n}\n.tr-kpi--ok { border-top-color: var(--green); }\n.tr-kpi--bad { border-top-color: var(--red); }\n.tr-kpi__label { font-size: 0.72rem; color: var(--text-secondary); font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; }\n.tr-kpi__value { font-size: 1.9rem; font-weight: 800; color: var(--text-primary); margin: 6px 0 2px; font-variant-numeric: tabular-nums; }\n.tr-kpi__target { font-size: 0.72rem; color: var(--text-muted); }\n\n/* ── States ── */\n.tr-empty { padding: 40px 24px; text-align: center; color: var(--text-muted); font-size: 0.85rem; }\n.training-error {\n  margin: 40px auto; max-width: 460px; padding: 20px; text-align: center; color: #fca5a5;\n  background: rgba(239,68,68,0.12); border: 1px solid rgba(239,68,68,0.3); border-radius: 12px;\n}\n.training-loading { padding: 60px; text-align: center; color: var(--text-secondary); }\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .training-layout { flex-direction: column; height: auto; }\n  .training-sidebar { width: 100%; min-width: 100%; height: auto; position: relative; border-right: none; border-bottom: 1px solid var(--border-subtle); }\n  .training-sidebar-nav { display: flex; flex-wrap: wrap; gap: 6px; }\n  .training-nav-section { margin-bottom: 0; }\n  .training-nav-section-title { display: none; }\n  .training-main { padding: 20px 16px; height: auto; }\n}\n\n/* ── Topbar ── */\n.tr-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-subtle);\n  position: sticky;\n  top: 0;\n  z-index: 40;\n}\n.tr-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n.tr-breadcrumbs {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n.tr-breadcrumbs strong {\n  color: var(--text-primary);\n  font-weight: 700;\n}\n.tr-search {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  border-radius: 9999px;\n  padding: 0.4rem 1rem 0.4rem 2.2rem;\n  color: var(--text-primary);\n  font-size: 0.82rem;\n  width: 280px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'%3E%3C/line%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: 10px center;\n  transition: all 0.2s;\n}\n.tr-search:focus {\n  outline: none;\n  border-color: rgba(59, 130, 246, 0.5);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n.tr-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.tr-user-dropdown {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n}\n.tr-user-dropdown:hover {\n  background: var(--bg-glass-hover);\n}\n.tr-topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.tr-topbar-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n.tr-topbar-btn:hover {\n  background: var(--bg-glass-hover);\n  color: var(--text-primary);\n}\n.tr-sync-btn-top {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  color: #60a5fa;\n  padding: 0.4rem 0.8rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.tr-sync-btn-top:hover {\n  background: rgba(59, 130, 246, 0.2);\n}\n.tr-topbar-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n  justify-content: flex-end;\n  padding-right: 24px;\n}\n\n/* ── Overview Tiles ── */\n.tr-tiles {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 2rem;\n  padding: 0 24px;\n}\n.tr-tile {\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  border-radius: 12px;\n  padding: 1.25rem;\n  text-align: left;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  box-shadow: var(--shadow-sm);\n}\n.tr-tile:hover {\n  background: var(--bg-glass-hover);\n  transform: translateY(-2px);\n}\n.tr-tile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--text-muted);\n}\n.tr-tile-value {\n  font-size: 2.5rem;\n  font-weight: 800;\n  line-height: 1;\n  margin: 0.75rem 0 0.25rem;\n  color: var(--text-primary);\n}\n.tr-tile-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n.tr-tile-sub {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-top: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n.tr-tile-sub.alert { color: #fca5a5; }\n.tr-tile-sub.warn { color: #fbbf24; }\n.tr-tile-sub.ok { color: var(--green); }\n\n/* ── Sidebar Badges & Footers ── */\n.nav-badge {\n  margin-left: auto;\n  background: var(--bg-glass);\n  color: var(--text-muted);\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.1rem 0.5rem;\n  border-radius: 9999px;\n}\n.training-nav-item.active .nav-badge {\n  background: rgba(16, 185, 129, 0.2);\n  color: var(--accent-emerald);\n}\n.sidebar-btn-outline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.5rem;\n  background: transparent;\n  border: 1px solid var(--border-subtle);\n  border-radius: 8px;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  transition: all 0.2s;\n}\n.sidebar-btn-outline:hover {\n  background: var(--bg-glass-hover);\n  color: var(--text-primary);\n}\n\n/* ── Action Buttons ── */\n.row-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.btn-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.3rem 0.7rem;\n  border-radius: 9999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  border: 1px solid var(--border-subtle);\n  background: var(--bg-glass);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.btn-action:hover {\n  background: var(--bg-glass-hover);\n}\n.btn-action-primary {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: rgba(59, 130, 246, 0.35);\n  color: #60a5fa;\n}\n.btn-action-primary:hover {\n  background: rgba(59, 130, 246, 0.25);\n}\n\n\n/* ── Tags / badges (pill) ── */\n.tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.15rem 0.55rem;\n  border-radius: 9999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  border: 1px solid var(--border-subtle);\n  background: var(--bg-glass);\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n.tag-neutral {\n  background: var(--bg-glass);\n  border-color: var(--border-subtle);\n  color: var(--text-muted);\n}\n.tag-green {\n  background: rgba(16, 185, 129, 0.12);\n  border-color: rgba(16, 185, 129, 0.35);\n  color: var(--green);\n}\n.tag-accent {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: rgba(59, 130, 246, 0.35);\n  color: #60a5fa;\n}\n.tag-danger {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(239, 68, 68, 0.35);\n  color: #fca5a5;\n}\n.tag-warn {\n  background: rgba(245, 158, 11, 0.12);\n  border-color: rgba(245, 158, 11, 0.35);\n  color: #fbbf24;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.15rem 0.55rem;\n  border-radius: 9999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  border: 1px solid transparent;\n}\n.badge .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n}\n.badge-green {\n  background: rgba(16, 185, 129, 0.12);\n  border-color: rgba(16, 185, 129, 0.35);\n  color: var(--green);\n}\n.badge-danger {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(239, 68, 68, 0.35);\n  color: #fca5a5;\n}\n.badge-warn {\n  background: rgba(245, 158, 11, 0.12);\n  border-color: rgba(245, 158, 11, 0.35);\n  color: #fbbf24;\n}\n\n/* ── Avatars ── */\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  font-weight: 700;\n  color: #0f111a;\n  flex-shrink: 0;\n}\n\n/* ── Meter ── */\n.meter {\n  position: relative;\n  height: 8px;\n  border-radius: 9999px;\n  background: var(--bg-glass);\n  overflow: hidden;\n}\n.meter-fill {\n  height: 100%;\n  border-radius: 9999px;\n  transition: width 0.4s ease;\n}\n.meter-target {\n  position: absolute;\n  top: -2px;\n  bottom: -2px;\n  width: 2px;\n  background: rgba(255, 255, 255, 0.45);\n  border-radius: 2px;\n}\n\n/* ── List shell / rows ── */\n.list-shell {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.list-row {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.9rem 1.1rem;\n  transition: background 0.2s ease;\n}\n.list-row + .list-row {\n  border-top: 1px solid var(--border-subtle);\n}\n.list-row:hover {\n  background: var(--bg-glass-hover);\n}\n\n.flex { display: flex; }\n.flex-col { flex-direction: column; }\n.items-center { align-items: center; }\n.items-start { align-items: flex-start; }\n.items-end { align-items: flex-end; }\n.justify-between { justify-content: space-between; }\n.justify-center { justify-content: center; }\n.justify-end { justify-content: flex-end; }\n.flex-1 { flex: 1; }\n.flex-wrap { flex-wrap: wrap; }\n.shrink-0 { flex-shrink: 0; }\n.min-w-0 { min-width: 0; }\n.gap-1 { gap: 0.35rem; }\n.gap-2 { gap: 0.6rem; }\n.gap-3 { gap: 0.85rem; }\n.ml-auto { margin-left: auto; }\n.mt-1 { margin-top: 0.35rem; }\n.mt-2 { margin-top: 0.6rem; }\n.mt-3 { margin-top: 0.85rem; }\n.text-right { text-align: right; }\n.text-center { text-align: center; }\n.truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.font-semibold { font-weight: 600; }\n.font-bold { font-weight: 700; }\n.text-xs { font-size: 0.72rem; }\n.text-sm { font-size: 0.82rem; }\n.whitespace-nowrap { white-space: nowrap; }\n.text-left { text-align: left; }\n\n.source-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  font-weight: 500;\n  white-space: nowrap;\n  transition: color 0.2s ease;\n}\n.source-link:hover {\n  color: var(--accent-emerald);\n}\n.row-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: var(--bg-glass);\n  color: var(--text-primary);\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n}\n.row-icon-pub {\n  background: rgba(16, 185, 129, 0.12);\n  color: var(--green);\n}\n\n.kpi-delta {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-top: 0.5rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n.kpi-good { color: var(--green); }\n.kpi-bad { color: var(--red); }\n.kpi-formula {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.35rem;\n  margin-top: 0.6rem;\n  font-size: 0.68rem;\n  line-height: 1.35;\n  color: var(--text-muted);\n}\n.kpi-foot {\n  margin-top: auto;\n  padding-top: 0.85rem;\n  margin-top: 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  border-top: 1px solid var(--border-subtle);\n}\n.kpi-hash {\n  font-family: ui-monospace, monospace;\n  font-size: 0.62rem;\n  color: var(--text-muted);\n}\n.stepper {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  max-width: 36rem;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.step {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.7rem;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n.step-done {\n  color: var(--green);\n}\n.step-cur {\n  color: var(--text-primary);\n  font-weight: 700;\n}\n.step-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  display: inline-block;\n}\n.step-dot-cur {\n  background: var(--green);\n}\n.step-dot-todo {\n  border: 1px solid var(--border-subtle);\n}\n.step-line {\n  width: 20px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--border-subtle);\n}\n.step-line-done {\n  background: rgba(16, 185, 129, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
